import { ApiQueryBuilder } from '../../core/api/helpers/api-query-builder.helper';
import { EmptyAdvancedSearch } from '../../core/query/entities/empty-structured-query.constant';
import { ApiStructuredQuery, RangeValue, StructuredQuery } from '../../core/query/entities/structured-query.entity';
import { QueryHandleQuotes } from '../../advanced-search/filters/base/entities/query-part-handle-quotes';

export function ApiStructuredQueryToStructuredQuery(apiStructuredQuery: ApiStructuredQuery): StructuredQuery {
    const advancedSearch = apiStructuredQuery.AdvancedSearch ?? EmptyAdvancedSearch;

    return {
        ...apiStructuredQuery,
        AdvancedSearch: advancedSearch,
        Fields: [],
        ColumnFilters: []
    };
}

export function StructuredQueryToApiStructuredQuery(structuredQuery: StructuredQuery): ApiStructuredQuery {
    return {
        // MED-6946 facets do not report correct counts -> use quotes to send exact terms (record search also uses quotes)
        Global: structuredQuery.Global.map(term => ApiQueryBuilder.sanitizeValue(term, QueryHandleQuotes.UseQuotes)),
        Semantic: structuredQuery.Semantic,
        FullText: ApiQueryBuilder.sanitizeValue(structuredQuery.FullText ?? ''),
        AdvancedSearch: structuredQuery.AdvancedSearch.Groups.length > 0 ? structuredQuery.AdvancedSearch : undefined,
        Facets: structuredQuery.Facets,
        Predefined: []
    };
}

export function dateRangeStringToRangeValue(value: string): RangeValue {
    const parsedValue: string[] = value.split(' TO ');

    if (parsedValue.length !== 2) {
        return {
            Begin: '',
            End: '',
            IncludeBegin: true,
            IncludeEnd: true
        };
    }

    return {
        Begin: parsedValue[0].slice(1),
        End: parsedValue[1].slice(0, -1),
        IncludeBegin: parsedValue[0].startsWith('['),
        IncludeEnd: parsedValue[1].endsWith(']')
    };
}

export function rangeValueToString(rangeValue: RangeValue): string {
    return `${rangeValue.IncludeBegin ? '[' : '{'}${rangeValue.Begin} TO ${rangeValue.End}${rangeValue.IncludeEnd ? ']' : '}'}`;
}
